import { ServiceTitanIconLink } from "@/core/components/service-titan-icon-link";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import type { ApPurchaseDocument } from "@/accounts-payable/types";
import {
  canManuallyMatchJob,
  hasManualPurchaseOrder,
  stFilingTarget,
  stPurchaseOrderUrl,
} from "@/accounts-payable/utils";
import { FieldWithAction } from "./field-with-action";
import { PurchaseOrderMatchButton } from "./purchase-order-match";

/**
 * The ServiceTitan PO a document's cost sits on, beside the action to choose
 * it by hand. Its own row under the job, which a PO choice can move.
 */
export const PurchaseOrderField = ({
  document,
  businessId,
}: {
  document: ApPurchaseDocument;
  businessId: string | null;
}) => {
  const poId = document.st_po_external_id ?? null;
  const manual = hasManualPurchaseOrder(document);

  return (
    <FieldWithAction
      label="Purchase order"
      action={
        canManuallyMatchJob(document) && (
          <PurchaseOrderMatchButton
            appearance="link"
            businessId={businessId}
            documentId={document.id}
            documentType={document.document_type}
            agentRunId={document.agent_run_id}
            hasJob={stFilingTarget(document) != null}
            label={poId ? "Change PO" : undefined}
          />
        )
      }
    >
      {poId ? (
        <Stack direction="row" gap={2} align="center" className="flex-wrap">
          {/* Same link styling as the job above it. */}
          <ServiceTitanIconLink
            url={stPurchaseOrderUrl(poId)}
            label={`Open purchase order #${poId} in ServiceTitan`}
            className="ml-0 text-lg text-link hover:text-link hover:underline"
          >
            #{poId}
          </ServiceTitanIconLink>
          {manual && <Text tone="muted">(chosen by hand)</Text>}
        </Stack>
      ) : manual ? (
        <Stack direction="row" gap={2} align="center">
          <Text>No existing PO</Text>
          <Text tone="muted">(set by hand)</Text>
        </Stack>
      ) : (
        <Text tone="muted">None recorded</Text>
      )}
    </FieldWithAction>
  );
};
